/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Import_Missing_DialogueInputs */



/**
* | output |
* | --- |
* | "Import Missing Dialogue" |
*
* @param {Offline_Sync_Import_Missing_DialogueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_import_missing_dialogue = /** @type {((inputs?: Offline_Sync_Import_Missing_DialogueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Import_Missing_DialogueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer les dialogues manquants")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehlenden Dialog importieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa dialogo mancante")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импортировать отсутствующие диалоги")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar diálogo faltante")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入缺失对话")
	if (locale === "ja") return /** @type {LocalizedString} */ ("不足している会話を取り込む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("गायब संवाद आयात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importar diálogo em falta")
	return /** @type {LocalizedString} */ ("Import Missing Dialogue")
});